import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from '@material-ui/core/styles/withStyles';
import {
  FormControl,
  FormHelperText,
  FormLabel,
  Input,
} from '@material-ui/core';
import customInputStyle from 'assets/jss/material-dashboard-pro-react/components/customInputStyle';

const CustomInput = ({ disabled = false, ...props }) => {
  const {
    classes,
    formControlProps,
    labelText,
    id,
    labelProps,
    inputProps,
    error,
    white,
    noArrowsNumberInput,
    success,
    helpText,
    type,
    maxLength = 255,
    overrideClasses = {},
    dataCy,
  } = props;
  const labelClasses = classNames({
    [classes.labelRoot]: true,
    [classes.labelRootError]: error,
    [classes.labelRootSuccess]: success && !error,
  });
  const underlineClasses = classNames({
    [classes.underlineError]: error,
    [classes.underlineSuccess]: success && !error,
    [classes.underline]: true,
    [classes.whiteUnderline]: white,
  });

  const inputClasses = classNames({
    [classes.input]: true,
    [classes.whiteInput]: white,
    [classes.noArrowsNumberInput]: noArrowsNumberInput,
  });

  let formControlClasses;
  // eslint-disable-next-line no-negated-condition -- FIXME
  if (formControlProps !== undefined) {
    formControlClasses = classNames(
      formControlProps.className,
      classes.formControl
    );
  } else {
    formControlClasses = classes.formControl;
  }
  const helpTextClasses = classNames({
    [classes.labelRootError]: error,
    [classes.labelRootSuccess]: success && !error,
  });

  return (
    <FormControl {...formControlProps} className={formControlClasses}>
      {labelText && (
        <FormLabel className={labelClasses} htmlFor={id} {...labelProps}>
          {labelText}
        </FormLabel>
      )}
      <Input
        data-cy={dataCy}
        classes={{
          input: inputClasses,
          root: classes.inputRoot,
          disabled: classes.disabled,
          underline: underlineClasses,
          ...overrideClasses,
        }}
        id={id}
        type={type || 'text'}
        inputProps={{
          ...(maxLength === 'none' ? {} : { maxLength }),
        }}
        disabled={disabled}
        {...inputProps}
      />
      {helpText && (
        <FormHelperText id={`${id}-text`} className={helpTextClasses}>
          {helpText}
        </FormHelperText>
      )}
    </FormControl>
  );
};

CustomInput.propTypes = {
  classes: PropTypes.object.isRequired,
  labelText: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  formControlProps: PropTypes.object,
  inputRootCustomClasses: PropTypes.string,
  error: PropTypes.bool,
  success: PropTypes.bool,
  white: PropTypes.bool,
  helpText: PropTypes.node,
  disabled: PropTypes.bool,
};

export default withStyles(customInputStyle)(CustomInput);
